import { TeamId } from '@/react/portainer/users/teams/types';

import { useAddons } from './useAddons';

/**
 * IDs of the enabled add-ons a team currently has access to. Team grants live
 * on the admin-only `record`, so this is empty for a non-admin.
 */
export function useTeamAddonIds(teamId: TeamId) {
  const addonsQuery = useAddons({
    select: (data) =>
      (data?.addons ?? [])
        .filter(
          (addon) => addon.enabled && addon.record?.teamAccessPolicies?.[teamId]
        )
        .map((addon) => addon.id)
        .filter((id): id is string => id != null),
  });

  return addonsQuery.data ?? [];
}
